import React, { useState, useEffect } from "react";
import ElementReport from "../elements/ElementReport";

const ContentToggleReport = (props) => {
  const element = props.element;
  const toggle_item = props.toggle_item;
  const [showElements, setShowElements] = useState(false);

  const row_elements =
    toggle_item.section?.elements
      .filter((el) =>
        [
          "form",
          "button",
          "survey",
          "quiz",
          "products",
          "product_hero",
          "scheduler",
          "embed",
        ].includes(el.element_type)
      )
      .sort((a, b) => (a.position || 0) - (b.position || 0)) || [];

  return (
    <React.Fragment>
      <div
        className="row hard-center element-selection-report"
        data-element-id={element.id}
        style={{
          width: "100%",
          display: row_elements.length > 0 ? "block" : "none",
        }}
        data-has-reports={`${row_elements.length > 0}`}
        data-report-id-prefix={props.reportIdPrefix || ""}
      >
        <div
          className="row hard-center"
          style={{ cursor: "pointer" }}
          onClick={() => {
            setShowElements(!showElements);
          }}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              setShowElements(!showElements);
            }
          }}
          role="button"
          tabIndex={0}
          aria-expanded={showElements}
        >
          <div className="col-xs-4 funnel-breakdown-question-label">
            <div
              className="text-xl field-report-toggle"
              data-toggle-item-id={toggle_item.id}
              style={{
                marginBottom: "5px",
                display: "flex",
                alignItems: "center",
              }}
              data-open={`${showElements}`}
            >
              <span
                className="ellipsis funnel-breakdown-question-text"
                style={{ minWidth: 0 }}
              >
                {element.element_type == "conditional_row"
                  ? `Conditional Row - ${toggle_item.content}`
                  : element.element_type == "carousel"
                  ? "Carousel "
                  : element.element_type == "tabs"
                  ? "Tab "
                  : element.element_type == "collapse"
                  ? "Collapse "
                  : "Content Toggle "}
              </span>
              {element.element_type !== "conditional_row" &&
                toggle_item.position != null && (
                  <span
                    className="funnel-breakdown-question-position"
                    style={{ flexShrink: 0 }}
                  >
                    {toggle_item.position}
                  </span>
                )}
              <span
                className={`glyphicon glyphicon-chevron-${
                  showElements ? "down" : "right"
                } element-selection-report-toggle ml-1`}
                style={{ flexShrink: 0 }}
              ></span>
            </div>
          </div>
        </div>

        {showElements && (
          <div
            className="row hard-center"
            style={{
              display: "flex",
              width: "100%",
              flexBasis: "100%",
              flexWrap: "wrap",
              flexDirection: "column-reverse",
              backgroundColor: "#fcfdfe",
              marginTop: "2px",
              paddingTop: "15px",
            }}
          >
            <div className="col-xs-12 element-reports">
              {row_elements.map((el) => {
                return (
                  <ElementReport
                    key={`element-${el.id}`}
                    cta={props.cta}
                    step={props.step}
                    element={el}
                    timeframeType={props.timeframeType}
                    range_start={props.range_start}
                    range_end={props.range_end}
                    externalProductValues={props.externalProductValues}
                    currency={props.currency}
                    gateReports={props.gateReports}
                    reportingGoals={props.reportingGoals}
                    reportIdPrefix={props.reportIdPrefix}
                  />
                );
              })}
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default ContentToggleReport;
